import { render, staticRenderFns } from "./DinnerInfo.vue?vue&type=template&id=61c8d141&scoped=true&"
import script from "./DinnerInfo.vue?vue&type=script&lang=js&"
export * from "./DinnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./DinnerInfo.vue?vue&type=style&index=0&id=61c8d141&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8d141",
  null
  
)

export default component.exports